import { useEffect, useState } from "react";
import { PortableText } from "@portabletext/react";
import NameList from "../../components/NameList";
import { useTranslation } from "react-i18next";

export default function OpenLetter() {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.resolvedLanguage;
  const query = `*%5B_type+%3D%3D+%22action%22+%26%26+language+%3D%3D+%22${currentLocale}%22%5D&perspective=published`;
  const url = `${process.env.REACT_APP_SANITY_API_URL}?query=${query}`;
  const [nrOfSignatures, setNrOfSignatures] = useState(0);
  const [openLetterContent, setOpenLetterContent] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        setOpenLetterContent(data.result[0]);
      } catch (error) {
        console.error("Failed to fetch content", error);
      } finally {
        console.log("Done");
      }
    };
    fetchData();
  }, [url]);

  const handleNrOfSignatures = (signatures: number) => {
    setNrOfSignatures(signatures);
  };

  return (
    <div className="page-container">
      {openLetterContent && (
        <div>
          <div id="swedish" className="white-space"></div>
          <div className="section-container">
            <div className="flex justify-between">
              <div>
                {" "}
                {new Date(openLetterContent.datePublished).toLocaleDateString(
                  currentLocale,
                  {
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  }
                )}
              </div>
              {nrOfSignatures > 0 && (
                <a href="#signatures" className="signature-link">
                  {nrOfSignatures} {t("signatures")}
                </a>
              )}
            </div>
            <h1>{openLetterContent.title}</h1>
            <PortableText value={openLetterContent.mainText} />
            {openLetterContent.signatureCollectionActive && (
              <div className="sign-link-container">
                <a
                  className="sign-link"
                  href={process.env.REACT_APP_GOOGLE_FORM_URL!}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t("sign_the_open_letter")}
                </a>
              </div>
            )}
          </div>
          <div>
            <div id="signatures" className="white-space"></div>
            <NameList onCsvData={handleNrOfSignatures}></NameList>
          </div>
        </div>
      )}
    </div>
  );
}
